import React, {useState} from 'react';
import {useLanguage} from '../../LanguageContext';
import {Box, IconButton, Menu, MenuItem} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

const TopMenuLanguageSwitcher = () => {
    const {changeLanguage} = useLanguage();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (lang) => {
        changeLanguage(lang); // Call your language switch function
        handleClose();
    };

    return (
        <Box>
            <IconButton onClick={handleClick} color="inherit">
                <LanguageIcon sx={{
                    fontSize: '32px'
                }}/>
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}
                  disableScrollLock={true}
                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                  transformOrigin={{vertical: "top", horizontal: "right"}}
            >
                <MenuItem onClick={() => handleLanguageChange("en")}>
                    English
                </MenuItem>
                <MenuItem onClick={() => handleLanguageChange("uk")}>
                    Українська
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default TopMenuLanguageSwitcher;
